import React from 'react';
import { useTranslation } from 'react-i18next';
import Header from '../components/Header';
import Footer from '../components/Footer';
import BackButton from '../components/BackButton';
import SEO from '../components/SEO';

const TermsPage: React.FC = () => {
  const { t } = useTranslation('legal');
  const { t: tSeo } = useTranslation('common');

  return (
    <div className='min-h-screen' style={{ background: 'rgb(8 6 20 / 100%)' }}>
      <SEO
        title={tSeo('seo.terms.title')}
        canonical='/terms'
        noIndex={true}
      />
      <Header showUserInfo={false} variant='player' />

      <div className='page'>
        <div className='container-mobile'>
          <BackButton />
          <div className='subtitle'>
            <h1
              style={{
                fontSize: '2.25rem',
                fontWeight: '700',
                color: 'var(--text-primary)',
                fontFamily: 'Lexend Deca, sans-serif',
                marginBottom: '1rem',
              }}
            >
              {t('terms.title')}
            </h1>
            <p style={{ color: 'var(--text-secondary)', fontSize: '0.9rem' }}>
              {t('terms.lastUpdated')}
            </p>
          </div>

          <div
            style={{
              color: 'var(--text-primary)',
              lineHeight: '1.8',
              fontSize: '1rem',
            }}
          >
            <section style={{ marginBottom: '2rem' }}>
              <h2
                style={{
                  fontSize: '1.5rem',
                  fontWeight: '600',
                  color: 'var(--text-primary)',
                  marginBottom: '1rem',
                  fontFamily: 'Lexend Deca, sans-serif',
                }}
              >
                {t('terms.section1.title')}
              </h2>
              <p
                style={{ marginBottom: '1rem', color: 'var(--text-secondary)' }}
              >
                {t('terms.section1.p1')}
              </p>
              <p
                style={{ marginBottom: '1rem', color: 'var(--text-secondary)' }}
              >
                {t('terms.section1.p2')}
              </p>
              <p style={{ color: 'var(--text-secondary)' }}>
                {t('terms.section1.p3')}
              </p>
            </section>

            <section style={{ marginBottom: '2rem' }}>
              <h2
                style={{
                  fontSize: '1.5rem',
                  fontWeight: '600',
                  color: 'var(--text-primary)',
                  marginBottom: '1rem',
                  fontFamily: 'Lexend Deca, sans-serif',
                }}
              >
                {t('terms.section2.title')}
              </h2>
              <p
                style={{ marginBottom: '1rem', color: 'var(--text-secondary)' }}
              >
                {t('terms.section2.p1')}
              </p>
              <p style={{ color: 'var(--text-secondary)' }}>
                {t('terms.section2.p2')}
              </p>
            </section>

            <section style={{ marginBottom: '2rem' }}>
              <h2
                style={{
                  fontSize: '1.5rem',
                  fontWeight: '600',
                  color: 'var(--text-primary)',
                  marginBottom: '1rem',
                  fontFamily: 'Lexend Deca, sans-serif',
                }}
              >
                {t('terms.section3.title')}
              </h2>

              <h3
                style={{
                  fontSize: '1.2rem',
                  fontWeight: '500',
                  color: 'var(--text-primary)',
                  marginBottom: '0.75rem',
                  marginTop: '1rem',
                }}
              >
                {t('terms.section3.sub1Title')}
              </h3>
              <p
                style={{ marginBottom: '1rem', color: 'var(--text-secondary)' }}
              >
                {t('terms.section3.sub1p1')}
              </p>

              <h3
                style={{
                  fontSize: '1.2rem',
                  fontWeight: '500',
                  color: 'var(--text-primary)',
                  marginBottom: '0.75rem',
                  marginTop: '1rem',
                }}
              >
                {t('terms.section3.sub2Title')}
              </h3>
              <p
                style={{
                  marginBottom: '0.5rem',
                  color: 'var(--text-secondary)',
                }}
              >
                {t('terms.section3.sub2p1')}
              </p>
              <p
                style={{ marginBottom: '1rem', color: 'var(--text-secondary)' }}
              >
                {t('terms.section3.sub2p2')}
              </p>

              <h3
                style={{
                  fontSize: '1.2rem',
                  fontWeight: '500',
                  color: 'var(--text-primary)',
                  marginBottom: '0.75rem',
                  marginTop: '1rem',
                }}
              >
                {t('terms.section3.sub3Title')}
              </h3>
              <p
                style={{
                  marginBottom: '0.5rem',
                  color: 'var(--text-secondary)',
                }}
              >
                {t('terms.section3.sub3p1')}
              </p>
              <p
                style={{ marginBottom: '1rem', color: 'var(--text-secondary)' }}
              >
                {t('terms.section3.sub3p2')}
              </p>

              <h3
                style={{
                  fontSize: '1.2rem',
                  fontWeight: '500',
                  color: 'var(--text-primary)',
                  marginBottom: '0.75rem',
                  marginTop: '1rem',
                }}
              >
                {t('terms.section3.sub4Title')}
              </h3>
              <p style={{ color: 'var(--text-secondary)' }}>
                {t('terms.section3.sub4p1')}
              </p>
            </section>

            <section style={{ marginBottom: '2rem' }}>
              <h2
                style={{
                  fontSize: '1.5rem',
                  fontWeight: '600',
                  color: 'var(--text-primary)',
                  marginBottom: '1rem',
                  fontFamily: 'Lexend Deca, sans-serif',
                }}
              >
                {t('terms.section4.title')}
              </h2>
              <p
                style={{ marginBottom: '1rem', color: 'var(--text-secondary)' }}
              >
                {t('terms.section4.p1')}
              </p>
              <p
                style={{ marginBottom: '1rem', color: 'var(--text-secondary)' }}
              >
                {t('terms.section4.p2')}
              </p>
              <p
                style={{
                  marginBottom: '0.5rem',
                  color: 'var(--text-secondary)',
                }}
              >
                {t('terms.section4.prohibitedIntro')}
              </p>
              <ul
                style={{
                  marginLeft: '2rem',
                  marginBottom: '1rem',
                  color: 'var(--text-secondary)',
                }}
              >
                <li style={{ marginBottom: '0.5rem' }}>{t('terms.section4.item1')}</li>
                <li style={{ marginBottom: '0.5rem' }}>{t('terms.section4.item2')}</li>
                <li>{t('terms.section4.item3')}</li>
              </ul>
            </section>

            <section style={{ marginBottom: '2rem' }}>
              <h2
                style={{
                  fontSize: '1.5rem',
                  fontWeight: '600',
                  color: 'var(--text-primary)',
                  marginBottom: '1rem',
                  fontFamily: 'Lexend Deca, sans-serif',
                }}
              >
                {t('terms.section5.title')}
              </h2>
              <p
                style={{
                  marginBottom: '0.5rem',
                  color: 'var(--text-secondary)',
                }}
              >
                {t('terms.section5.p1')}
              </p>
              <p style={{ color: 'var(--text-secondary)' }}>
                {t('terms.section5.p2')}
              </p>
            </section>

            <section style={{ marginBottom: '2rem' }}>
              <h2
                style={{
                  fontSize: '1.5rem',
                  fontWeight: '600',
                  color: 'var(--text-primary)',
                  marginBottom: '1rem',
                  fontFamily: 'Lexend Deca, sans-serif',
                }}
              >
                {t('terms.section6.title')}
              </h2>
              <p
                style={{
                  marginBottom: '0.5rem',
                  color: 'var(--text-secondary)',
                }}
              >
                {t('terms.section6.p1')}
              </p>
              <p
                style={{
                  marginBottom: '0.5rem',
                  color: 'var(--text-secondary)',
                }}
              >
                {t('terms.section6.p2')}
              </p>
              <p
                style={{
                  marginBottom: '0.5rem',
                  color: 'var(--text-secondary)',
                }}
              >
                {t('terms.section6.p3')}
              </p>
              <p style={{ color: 'var(--text-secondary)' }}>
                {t('terms.section6.p4')}
              </p>
            </section>

            <section style={{ marginBottom: '2rem' }}>
              <h2
                style={{
                  fontSize: '1.5rem',
                  fontWeight: '600',
                  color: 'var(--text-primary)',
                  marginBottom: '1rem',
                  fontFamily: 'Lexend Deca, sans-serif',
                }}
              >
                {t('terms.section7.title')}
              </h2>
              <p
                style={{
                  marginBottom: '0.5rem',
                  color: 'var(--text-secondary)',
                }}
              >
                {t('terms.section7.p1before')}<a href='/privacy'>{t('terms.section7.p1link')}</a>.
              </p>
              <p style={{ color: 'var(--text-secondary)' }}>
                {t('terms.section7.p2')}
              </p>
            </section>

            <section style={{ marginBottom: '2rem' }}>
              <h2
                style={{
                  fontSize: '1.5rem',
                  fontWeight: '600',
                  color: 'var(--text-primary)',
                  marginBottom: '1rem',
                  fontFamily: 'Lexend Deca, sans-serif',
                }}
              >
                {t('terms.section8.title')}
              </h2>
              <p
                style={{
                  marginBottom: '0.5rem',
                  color: 'var(--text-secondary)',
                }}
              >
                {t('terms.section8.p1')}
              </p>
              <p style={{ color: 'var(--text-secondary)' }}>
                {t('terms.section8.p2')}
              </p>
            </section>

            <section style={{ marginBottom: '2rem' }}>
              <h2
                style={{
                  fontSize: '1.5rem',
                  fontWeight: '600',
                  color: 'var(--text-primary)',
                  marginBottom: '1rem',
                  fontFamily: 'Lexend Deca, sans-serif',
                }}
              >
                {t('terms.section9.title')}
              </h2>
              <p style={{ color: 'var(--text-secondary)' }}>
                {t('terms.section9.p1')}
              </p>
            </section>

            <section style={{ marginBottom: '2rem' }}>
              <h2
                style={{
                  fontSize: '1.5rem',
                  fontWeight: '600',
                  color: 'var(--text-primary)',
                  marginBottom: '1rem',
                  fontFamily: 'Lexend Deca, sans-serif',
                }}
              >
                {t('terms.section10.title')}
              </h2>
              <p
                style={{ marginBottom: '1rem', color: 'var(--text-secondary)' }}
              >
                {t('terms.section10.intro')}
              </p>
              <div
                style={{
                  paddingLeft: '1.5rem',
                  color: 'var(--text-secondary)',
                  borderLeft: '3px solid var(--text-secondary)',
                  marginLeft: '1rem',
                }}
              >
                <p style={{ marginBottom: '0.5rem' }}>
                  <strong>{t('terms.section10.company')}</strong>
                </p>
                <p style={{ marginBottom: '0.5rem' }}>
                  {t('terms.section10.email')}
                </p>
                <p>{t('terms.section10.website')}</p>
              </div>
            </section>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default TermsPage;
